module.exports = __webpack_public_path__ + "img/FAQ.7976313d.svg";